module.exports = __webpack_public_path__ + "img/1791993033688.18266d85.png";